/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { ClrSyntaxHighlightModule } from "./syntax-highlight/syntax-highlight.module";
var ClrCodeModule = (function () {
    function ClrCodeModule() {
    }
    return ClrCodeModule;
}());
export { ClrCodeModule };
ClrCodeModule.decorators = [
    { type: NgModule, args: [{
                exports: [ClrSyntaxHighlightModule]
            },] },
];
/** @nocollapse */
ClrCodeModule.ctorParameters = function () { return []; };
//# sourceMappingURL=code.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/code/code.module.js
// module id = 284
// module chunks = 4